// ------------------------------------
// props 輸入需求 :
// props.hide : function( void )                    ( 開關按鈕 )
// props.data : object : { data: array }            (  )
// ------------------------------------

import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ApiGo from '../../../actions/ApiGo';
import { ADD_RESIDENTS_ARRAY } from '../../../stores/reducer_residentsArray';
import { ADD_USERS_ARRAY } from '../../../stores/reducer_usersArray';
import ResidentArr from './ResidentArr';
import './_assign.scss'
import Mos from '../../../actions/Mos';

const AssignResident = (props) => {
    // selection effect
    const [selectionEff, setSelectionEff] = useState(false);
    const [t] = useTranslation()
    const mos = Mos()
    let doctor = props.data
    // ~~~~~~~~~~~~~~~~~~~~~~ resident 陣列組合 ~~~~~~~~~~~~~~~~~~~~
    const [firstTime, setFirstTime] = useState(false);
    const [resident_arr, setResident_arr] = useState([]);
    const [remove_arr, setRemove_arr] = useState([]);
    const [add_arr, setAdd_arr] = useState([]);
    const [resident_with_userID_arr, setResident_with_userID_arr] = useState([]);
    // ~~~~~~~~~~~~~~~~~~~~~~ resident 陣列組合 ~~~~~~~~~~~~~~~~~~~~

    // redux
    const dispatch = useDispatch()
    const store_residents_array = useSelector(state => state.store_residents)

    // --------------- update redux ---------------
    const [UpdateRedux, setUpdateRedux] = useState(false);
    useEffect(() => {
        if (UpdateRedux) {
            ApiGo.getUsers().then(res => { dispatch(ADD_USERS_ARRAY(res.users)) })
            ApiGo.getResidents().then(res => { dispatch(ADD_RESIDENTS_ARRAY(res)) })
            props.hide()
        }
    }, [UpdateRedux]);
    // --------------- redux ---------------
    // redux
    useEffect(() => {
        let _resident = store_residents_array.orign_residents_array || []
        setResident_arr(resident_obj_to_arr(_resident))
        setFirstTime(true)
    }, [store_residents_array])

    useEffect(() => {
        if (firstTime) {
            let _row = resident_arr
            let _result = matchResident(doctor.resident_assign, _row)
            setResident_with_userID_arr(_result[0])
            _result[1].forEach(res => { _row.splice(res, 1) })
            setResident_arr(_row)
            setFirstTime(false)
        }
        function matchResident(arr, res_row) {
            let _returnArr = []
            let _index_arr = []
            res_row.forEach((res, index) => {              // resident all
                arr.forEach(str => {                       // resident str assigned
                    let _str_arr = str.split(" ")
                    if (_str_arr[1] === res[1] && _str_arr[0] === res[0]) {
                        _returnArr.push(res)
                        _index_arr.push(index)
                    }
                })
            })
            return [_returnArr, _index_arr.reverse()]
        }
    }, [firstTime, resident_arr, doctor.resident_assign])


    function putPromise(add) {
        return new Promise((resolve, reject) => {
            let _data = {
                email: doctor.email,
                role: doctor.role,
                resident_assign: add.join()
            }
            ApiGo.putCreate_Residents_Assign(_data)
                .then(res => { resolve(res); })
                .catch(err => { resolve(err) })
        })
    }

    function deletePromise(remove) {
        return new Promise((resolve, reject) => {
            let _data = {
                email: doctor.email,
                role: doctor.role,
                resident_assign: remove.join()
            }
            ApiGo.deleteDelete_Residents_Assign(_data)
                .then(res => { resolve(res.status) })
                .catch(err => { resolve(err) })       // 這裡要讓他 resolve 因為原先沒有配resident的話會回 500，這仍要讓他過!!
        })
    }

    function assign_Delete_Resident() {
        setUpdateRedux(false)
        let _add = add_arr.map(res => res[2])
        let _remove = remove_arr.map(res => res[2])
        deletePromise(_remove)
            .then(() => {
                putPromise(_add).then(() => { setUpdateRedux(true) })
                    .catch(err => { console.log(err); })
            })
            .catch(err => { console.log(err); })
        mos.sendPayload('line_notify/resetResident', 'reset')
    }


    function resident_obj_to_arr(arr) {
        let _returnArr = []
        arr.forEach(res => { _returnArr.push([res.first_name, res.last_name, res.id]) })
        return _returnArr
    }

    function removeFromResident_arr(id) {
        let _index = resident_arr.indexOf(id)
        resident_arr.splice(_index, 1)
        add_arr.push(id)
        setAdd_arr(add_arr)
    }

    function removeFromAdd_arr(id) {
        let _index = add_arr.indexOf(id)
        add_arr.splice(_index, 1)
        remove_arr.push(id)
        setRemove_arr(remove_arr)
    }

    function removeFromRemove_arr(id) {
        let _index = remove_arr.indexOf(id)
        remove_arr.splice(_index, 1)
        add_arr.push(id)
        setAdd_arr(add_arr)
    }

    function removeFromResident_with_userID_arr(id) {
        let _index = resident_with_userID_arr.indexOf(id)
        resident_with_userID_arr.splice(_index, 1)
        remove_arr.push(id)
        setRemove_arr(remove_arr)
    }

    return (
        <div onClick={props.hide} className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-black">
            <div className=' fx-d-c fx-ncfs h-80 w-80'>
                <div className='w-100 h-20 fx-d-r assign_frame'>
                    <div className='w-20 h-100 pad-45 l r assign_layout font-xl fx-d-c fx-ccc' onClick={e => e.stopPropagation()}>
                        {/* {t("NAV_BAR.USERS").split("").map((res, index)=><div key={index} className='side-font'>{res}</div>)} */}

                        {t("NAV_BAR.USERS")}
                    </div>
                    <div className="w-40 h-100 assign_layout font-exlarge fx-ccc" onClick={e => e.stopPropagation()}>
                        {doctor.name}
                    </div>
                    <div className='forCrossframe'>
                        <div className='box cross light fx-ccc assign_layout'></div>
                    </div>
                </div>

                <div className="w-100 h-40 assign_frame fx-d-r" onClick={e => e.stopPropagation()}>
                    <div className='w-20 h-100 pad-45 l r assign_layout font-xl fx-d-c fx-ccc'>
                        {/* {t("GLOBAL.UNASSIGNED").split("").map((res, index) => <div key={index} className='side-font'>{res}</div>)} */}
                        {t("GLOBAL.UNASSIGNED") }
                    </div>
                    <div className='w-80 h-100 assign_layout ovy-a fx-d-r flex-wrap'>
                        {resident_arr.map((res, index) => {
                            return (
                                <ResidentArr
                                    key={index}
                                    type={"none"}
                                    setSelectionEff={setSelectionEff}
                                    selectionEff={selectionEff}
                                    remove={removeFromResident_arr}
                                    res={res} />
                            )
                        })}
                        {remove_arr.map((res, index) => {
                            return (
                                <ResidentArr
                                    key={index}
                                    type={"remove"}
                                    setSelectionEff={setSelectionEff}
                                    selectionEff={selectionEff}
                                    remove={removeFromRemove_arr}
                                    res={res} />
                            )
                        })}
                    </div>
                </div>
                <div className="w-100 h-20 assign_frame fx-d-r">
                    <div className='w-20 h-100 pad-45 l r assign_layout font-xl fx-d-c fx-ccc' onClick={e => e.stopPropagation()}>
                        {/* {t("GLOBAL.ASSIGNED").split("").map((res, index) => <div key={index} className='side-font'>{res}</div>)} */}
                        
                        {t("GLOBAL.ASSIGNED") }
                    </div>
                    <div className='w-60 h-100 assign_layout fx-d-r ovy-a flex-wrap' onClick={e => e.stopPropagation()}>
                        {resident_with_userID_arr.map((res, index) => {
                            return (
                                <ResidentArr
                                    key={index}
                                    type={"none"}
                                    setSelectionEff={setSelectionEff}
                                    selectionEff={selectionEff}
                                    remove={removeFromResident_with_userID_arr}
                                    res={res} />
                            )
                        })}
                        {add_arr.map((res, index) => {
                            return (
                                <ResidentArr
                                    key={index}
                                    type={"add"}
                                    setSelectionEff={setSelectionEff}
                                    selectionEff={selectionEff}
                                    remove={removeFromAdd_arr}
                                    res={res} />
                            )
                        })}
                    </div>
                    <div className='w-20 h-100 fx-d-c fx-csbc align-items-end' onClick={e => e.stopPropagation()}>
                        <div className='assign_layout _btn font-xxl fx-ccc'
                            onClick={assign_Delete_Resident}>
                            {t("GLOBAL.CONFIRM")}
                        </div>
                        <div className='assign_layout _btn font-xxl fx-ccc' onClick={props.hide}>
                            {t("GLOBAL.CANCEL")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default AssignResident;